var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "highlight-item-container" }, [
    _c(
      "div",
      { staticClass: "highlight-item" },
      [
        _c("div", { staticClass: "col primary-image-container" }, [
          _c("img", {
            staticClass: "primary-image",
            attrs: { src: _vm.options.primary_image.url }
          })
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col content content-padding bg-white" }, [
          _vm.options.content.top_title
            ? _c("div", {
                staticClass: "top-title",
                domProps: { innerHTML: _vm._s(_vm.options.content.top_title) }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.options.content.title
            ? _c("h2", {
                staticClass: "title",
                domProps: { innerHTML: _vm._s(_vm.options.content.title) }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.options.content.description
            ? _c("div", {
                staticClass: "description",
                domProps: { innerHTML: _vm._s(_vm.options.content.description) }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.options.content.button
            ? _c("div", { staticClass: "button-container" }, [
                _c("a", {
                  staticClass: "hover-button orange",
                  attrs: {
                    href: _vm.options.content.button.url,
                    target: _vm.options.content.button.target
                  },
                  domProps: {
                    innerHTML: _vm._s(_vm.options.content.button.title)
                  }
                })
              ])
            : _vm._e()
        ]),
        _vm._v(" "),
        _vm.options.secondary_images
          ? _c("div", { staticClass: "col" }, [
              _c(
                "div",
                {
                  staticClass: "secondary-image-container secondary-container"
                },
                _vm._l(_vm.options.secondary_images, function(image, index) {
                  return _c("img", { key: index, attrs: { src: image.url } })
                }),
                0
              )
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm._t("custom-column")
      ],
      2
    ),
    _vm._v(" "),
    _c("div", { staticClass: "mobile-highlight-item" }, [
      _c("div", { staticClass: "case-study card" }, [
        _c("img", {
          staticClass: "primary-image",
          attrs: { src: _vm.options.primary_image.url }
        }),
        _vm._v(" "),
        _vm.options.content.title
          ? _c("h2", {
              staticClass: "title",
              domProps: { innerHTML: _vm._s(_vm.options.content.title) }
            })
          : _vm._e(),
        _vm._v(" "),
        _vm.options.content.button
          ? _c("div", { staticClass: "button-container" }, [
              _c("a", {
                staticClass: "hover-button orange",
                attrs: {
                  href: _vm.options.content.button.url,
                  target: _vm.options.content.button.target
                },
                domProps: {
                  innerHTML: _vm._s(_vm.options.content.button.title)
                }
              })
            ])
          : _vm._e()
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }